// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationItem_container__3QYpi"};